import roles from "../constants/roles";
import store from "../../store";

const hasPermission = function (permission) {
  if (isSuperAdmin(store.getters["auth/role"])) return true;
  const allPermissions = store.getters["auth/permissions"];
  return allPermissions ? allPermissions.includes(permission.toLowerCase()) : false;
}

const hasAnyOfPermissions = function (permissions) {
  if (isSuperAdmin(store.getters["auth/role"])) {
    return true;
  }

  const allPermissions = store.getters["auth/permissions"];

  if (!allPermissions) {
    return false;
  }

  for (let i = 0; i < permissions.length; i++) {
    if (allPermissions.includes(permissions[i])) {
      return true;
    }
  }

  return false;
}

const hasRole = function (roles, role = store.getters["auth/role"]?store.getters["auth/role"].toLowerCase():null) {
  return role?roles.includes(role):false;
}

const isSuperAdmin = function (role) {
  return role.toLowerCase() === roles.SUPER_ADMIN
}

const isLocalAdmin = function (role) {
  return role.toLowerCase() === roles.LOCAL_ADMIN
}

const isAdmin = function (role) {
  return (role.toLowerCase() === roles.SUPER_ADMIN || role.toLowerCase() === roles.LOCAL_ADMIN)
}

const isWorker = function (role) {
  return role.toLowerCase() === roles.WORKER
}

const isApprover = function (role) {
  return role.toLowerCase() === roles.APPROVER
}

const isVendor = function (role) {
  return role.toLowerCase() === roles.VENDOR
}

export {
  hasRole,
  hasPermission,
  hasAnyOfPermissions,
  isApprover,
  isLocalAdmin,
  isSuperAdmin,
  isAdmin,
  isWorker,
  isVendor
}
